// Sources of the games engine alone (without the official games): loaded by the sandbox page.
import sdk from './sdk.js?raw';
import boot from './boot.js?raw';

/** SDK (before the game code) and message bootstrap (after), concatenated in the worker. */
export const GAME_RUNTIME = { sdk, boot };
/** Lines added before the game code: to map an error line number back to the game's. */
export const GAME_CODE_OFFSET = sdk.split('\n').length + 1;
